import React from "react";

// Todo: use this function for getting the data
//import { getTestimonialData } from "./testimonials-fn";

import "../global.scss";
import "./testimonials.scss";

function Testimonials() {
    return (
        <div className="testimonials">
            <h3 className="title">Salty Testimonials</h3>
            <div className="testimonial">
                <div className="testimonial-text quote">
                    &quot;I&apos;ve been booking Salty to play at Malones since 2019 and they have been consistently professional, reliable and easy 
                    to work with. They play great songs you don&apos;t hear from other cover bands and never fail to provide our patrons with a 
                    night of memorable music and entertainment. Highly recommended! They may be Salty, but they&nbsp;re still sweet! #greatforbusiness&quot;
                </div>
                <div className="testimonial-author">
                    - Sara-Lynne, Owner <a href="https://www.pubsbarrie.ca/" target="_blank" rel="noopener noreferrer">Malones Pint House, Barrie</a>
                </div>
            </div>
            <div className="testimonial">
                <div className="testimonial-text quote">
                    &quot;We love you guys, as a huge fan of live music Salty is right up my ally, playing all of my favorite songs to dance to.
                    as a manager of a pub hiring Salty was easy peazy. Great guys to work with and super, fun thanks guys see you next time!&quot;
                </div>
                <div className="testimonial-author">
                    - Michelle, Manager, <a href="http://www.lionandunicorn.ca/" target="_blank" rel="noopener noreferrer">Lion &amp; Unicorn, Whitby</a>
                </div>
            </div>
            <div className="testimonial">
                <div className="testimonial-text quote">
                    &quot;When Salty comes to town, you can find me in the front row and I never miss a chance to catch them live. As a singer and musician, 
                    I&apos;m inspired by each performance. Guitar, Bass and Drums - A simple instrumental set-up, but Brian, Gavin and Jono are compelling, 
                    virtuosic and transcend simplicity to fill the room with talent and sound. I am a fan and I am Salty.&quot;
                </div>
                <div className="testimonial-author">
                    - Derek Marshall, Vocalist / Entertainer / Man About Town, <a href="http://www.derekmarshall.ca/" target="_blank" rel="noopener noreferrer">Derek Marshall</a>
                </div>
            </div>
            <div className="testimonial">
                <div className="testimonial-text quote">
                    &quot;I have had Salty in my pub several times over the years. They are always professional in their dealings with both myself and
                    my staff. Salty is a top notch band who deliver great music and who are easy to deal with.&quot;
                </div>
                <div className="testimonial-author">
                    - Prad Annalingam, Owner and Manager, <a href="http://www.shamrockswhitby.com/" target="_blank" rel="noopener noreferrer">Shamrock's Pub and Grillhouse</a>
                </div>
            </div>
            <div className="testimonial">
                <div className="testimonial-text quote">
                    &quot;Salty was kickass! They played a wide variety of rockin' tunes to get everyone movin' n' groovin'- kept it up all night 
                    long-great musicians, great guys, cannot wait to see them live again in the very near future!!!!&quot;
                </div>
                <div className="testimonial-author">
                    - Ross Davies, hired Salty for a private party, huge music fan
                </div>
            </div>
        </div>
    );
}

export default Testimonials;